import * as actionTypes from './actionTypes';

export const getApplicationDetailsSuccess = response => {
    return {
        type: actionTypes.GET_APPLICATION_DETAILS_SUCCESS,
        response,
    };
};

export const getApplicationDetailsFailed = error => {
    return {
        type: actionTypes.GET_APPLICATION_DETAILS_FAILED,
        error,
    };
};

export const getApplicationDetailsStart = Id => {
    return {
        type: actionTypes.GET_APPLICATION_DETAILS,
        sessionId: Id,
    };
};
